<template>
  <el-container class="busi-check-wrap">
    <div v-if="showType == 1">
      <preCheckList :checkList="[{ HANDLE_TIP: $txtcfg.JTYYY }]"></preCheckList>
    </div>
    <template v-if="showType==2">
      <section class="content-wrap">
        <div class="content">
          <img src="../../../static/assets/img/newCode/bizCheck/failIcon.png" />
          <p>{{ rejectTitle }}</p>
          <div class="failReasonCon">
            <p>驳回原因如下：</p>
            <p v-for="(item, index) in rejectImgList" :key="index" class ="fail-style">{{ item }}</p>
          </div>
        </div>
      </section>
      <footer>
        <!-- <el-button @click="leaveBiz">我不想申请了</el-button> -->
        <el-button @click="() => continueBiz()">我要修改</el-button>
      </footer>
    </template>
  </el-container>
</template>

<script>
import oppService from "@/service/opp-service";
import custService from "@/service/cust-service";
import preCheckList from "@/components/common/preCheckList";
export default {
  data () {
    return {
      loading: true,
      showType: 0, // showType = 1, 强制预约业务提示；showType = 2，驳回业务提示
      rejectImgList: [], //驳回的影像列表
      rejectTitle: "",
      bsno: null,
      dualRecordBusiData: {}, //当前业务关联的双录流水数据
      bizData: {},
      goToImgFlag: false
    };
  },
  // props: [ "userType"],
  components: {
    preCheckList
  },
  watch: {
    showType (v) {
      if (v == 2) {
        this.showRejectMSgBox();
      }
    },
    loading (v) {
      if (v) {
        this.myLoading({
          
          loadingText: "正在核对您的业务状态&请稍候...",
          autoHide: false
        });
      } else {
        this.myLoading({
          showLoading: false
        });
      }
    }
  },
  mounted () {
    let that = this;
    that.$store.commit(that.$types.UPDATE_IS_JUMPTO_IAMGE, "0");//更新是否跳过资料录入直接到影像采集节点
    that.initBiz().then(async data => {
      that.loading = false;
      // that.$store.commit(that.$types.UPDATE_BUSI_CODE, that.busiCode);
      // that.$store.commit(that.$types.UPDATE_USER_TYPE, that.userType);
      let decodeData = data && data.ACCEPT_PARAM && JSON.parse(decodeURIComponent(data.ACCEPT_PARAM)),
        dealParam = data.DEAL_PARAM && JSON.parse(decodeURIComponent(data.DEAL_PARAM)) || {},
        onlyRejectUser = dealParam.onlyRejectUser && dealParam.onlyRejectUser.split(",").filter(v => v != 0) || [];
      // if (onlyRejectUser.length) { //驳回过工作人员
      //   that.$storage.setSession(that.$definecfg.IMAGE_REJECT_TYPE, onlyRejectUser);
      //   that.$store.commit(that.$types.UPDATE_IS_JUMPTO_IAMGE, "1");
      //   that.goToImgFlag = true;
      // }
      that.failReject = dealParam.failReject;
      if (
        oppService.getBusiCommonParamsByCode(that.bizCommParam, "IS_MUST_APPT") == "1" &&
        that.bsno == null &&
        (!decodeData ||
          (decodeData && !decodeData.APPT_SN) ||
          (data && data.PROC_STATUS == "11"))
      ) {
        // 此业务需要先预约 预约完成的业务（预约完成的业务会在流水里保存APPT_SN），可以继续办理 预约后vtm提交到审核驳回的，不能办理，重新预约
        that.showType = 1;
      } else if (data && !_.isEmpty(data)) {
        that.bizData = data;
        // customerCheck已经保存过了
        // that.$store.commit(that.$types.UPDATE_OLD_BIZ_DATA, data);
        //续办跳转影像节之前，把历史流水保存到session里的BUSI_INFO，还原历史流水数据,防止影像节点取不到流水数据
        //VTM-5631 生产问题，客户资料变更，客户没有修改中登字段，续办时却采集了中登表单
        if (!_.isEmpty(data)) {
          let bdata = await oppService.parseAcceptParam(
            _.cloneDeep(this.$store.state.oldBizData)
          );
        }
        consoleLog("bizcheck复用历史流水号", data.B_SNO);
        data.B_SNO && that.$store.commit(that.$types.UPDATE_B_SNO, data.B_SNO); 
        decodeData &&
          decodeData.APPT_SN &&
          data.PROC_STATUS != "00" &&
          that.$storage.setSession(
            that.$definecfg.APPT_SN,
            decodeData["APPT_SN"]
          );

        if (this.bizData.PROC_STATUS == "11" && ["3","12"].includes(this.$store.state.apptStatus)) {
          that.showType = 2;
        } else {
          //只驳回工作人员单个节点 直接去到影像采集
          if (onlyRejectUser.length == 1) {
            that.continueBiz();
          } else if (that.bizData.NODE_CODE && that.bizData.NODE_CODE > -1) {
            let routerIndex = parseInt(this.bizData.NODE_CODE) + 1;
            let isMatch = decodeData.MATCH_FLAG || decodeData.IS_MATCH || decodeData.MATCH_RESULT || undefined,
              riskSurveySn = oppService.getBusiCommonParamsByCode(that.bizCommParam, "PROPER_RISK_SURVEY_SN");
            //非开户业务，获取客户最新适当性数据，如果变更则从头办理; 检查公参PROPER_RISK_SURVEY_SN，如没配置不需要检查适当性
            if (!that.$syscfg.isOpenAcctBiz(that.busiCode) && ["0", "1"].includes(isMatch) && routerIndex > 0 && riskSurveySn.length) {
              consoleLog("判断适当性数据--begin");
              let custInfo = this.$storage.getJsonSession(this.$definecfg.CUSTOMER_INFO) || {};
              //客户流水里存在适当性数据，需要跟最新的客户适当性数据比对，通过了才能续办，不通过就只能从头开始办理，不能直接跳转
              let basedata = {
                BUSI_CODE: that.busiCode,
                USER_TYPE: that.userType,
                ID_TYPE: custInfo.ID_TYPE,
                ID_CODE: custInfo.ID_CODE,
                CUST_CODE: custInfo.CUST_CODE,
                CUST_FNAME: custInfo.CUST_NAME || custInfo.USER_FNAME,
                INT_ORG: custInfo.INT_ORG,
                TRDACCT_EXCLS: that.userType == "0" ? "0" : "1",
              };
              let MATCH_OBJ = await custService.assembleCustMatchData(basedata); //MATCH_RESULT 0-一致-匹配  1-不一致-不匹配
              if (MATCH_OBJ && MATCH_OBJ.MATCH_FLAG !== isMatch) {
                consoleLog("您的适当性匹配数据发生变化,请重新办理业务！");
                that.$router.goNext();
                return;
              }
            }
         
            //如果只有见证岗权限，需要做以下限制
            //1.当流水状态为6风险揭示完成，8-见证中，9见证完成 之后的任何状态，且不是驳回状态时 柜员只有见证岗权限时，默认跳转到见证节点
            if(!this.editAuth && this.witnessAuth){
              if(this.apptStatus >= 6 && this.apptStatus !=12){
                this.goToWitness();
                return;
              }
            }
            // 查看业务详情,从第一个路由开始,字段不允许修改
            if (that.$syscfg.consts().ACCEPT_NO_UPDATE_APPT_STATUS.includes(this.apptStatus) 
            // || that.$syscfg.consts().REJECT_APPT_STATUS.includes(this.apptStatus)
            ) {
              that.$router.goNext();
              return;
            }
            consoleLog("续办跳到" + routerIndex);
            if (this.apptStatus>=4) {
              //流程大于预审核通过 需要跳过预审流程详情
              let routeObj = this.$router.getRoute(routerIndex);
              if(routeObj.name === "流程详情"){
                that.$router.goRoute(routerIndex + 1);
                return;
              }
            }       
            that.$router.goRoute(routerIndex);
          } else {
            that.$router.goNext();
          }
        }
      } else {
        // 没有可复用的历史流水
        that.$store.commit(that.$types.UPDATE_OLD_BIZ_DATA, {});
        that.$router.goNext();
      }
    }).catch(err => {
      that.loading = false;
      consoleError("业务准入校验失败，原因：" + err);
      that.alert({
        messageText: "业务准入校验失败，" + err + "，请联系管理员！",
        confirmedAction: () => {
          that.goToHome();
        }
      });
    });
  },
  destroyed () {
    //删除准入的路由信息
    // this.$router.deleteRoute(0);
  },
  computed: {
    userInfo: function () {
      return this.$storage.getJsonSession(this.$definecfg.USER_INFO) || {};
    },
    customerInfo: function () {
      return this.$storage.getJsonSession(this.$definecfg.CUSTOMER_INFO) || {};
    },
    bizCommParam () {
      return this.$storage.getJsonLocal(this.$definecfg.BUSI_COMM_PARAM);
    },
    bizConfig () {
      return this.$bizcfg.getBizConfig(this.busiCode, this.userType);
    },
    rejectRoutes () {
      // 业务驳回时驳回节点对应的路由表路由
      return "rejectRoutes" in this.bizConfig ? this.bizConfig["rejectRoutes"] : {};
    },
    isLogin () {
      return this.$store.state.isLogin;
    },
    busiCode () {
      return this.$store.state.busicode;
    },
    userType () {
      return this.$store.state.usertype;
    },
    apptStatus () {
      return this.$store.state.apptStatus;
    },
    editAuth (){
      return this.$store.state.permission.editAuth;
    },
    checkAuth (){
      return this.$store.state.permission.checkAuth;
    },
    witnessAuth (){
      return this.$store.state.permission.witnessAuth;
    },
  },
  methods: {
    showRejectMSgBox () {
      let that = this, errorTitle = "审核驳回，重新修改完后再提交！";
     
      
      if (that.apptStatus == "3") {
        errorTitle = "预审核被驳回，重新修改完后再提交！";
      }
      if (that.apptStatus == "12") {
        errorTitle = "终审被驳回，重新修改完后再提交";
      }
      that.rejectTitle = errorTitle;
      that.rejectImgList = that.bizData.REMARK.split("●");
    },
    initBiz () {
      //如果customerCheck已经获取过流水则直接返回
      let oldBizData = this.$store.state.oldBizData;
      if (!_.isEmpty(this.$store.state.oldBizData)) {
        return Promise.resolve(this.$store.state.oldBizData);
      } else {
        return Promise.resolve(false);
      }
    },
    goToImageCollectNodeDirectly () {
      this.$router.replace({ path: "/imageAcquisition", query: { "isJumpToImageCollect": "1" } });
    },
    goToWitness (){
      this.$router.goRoute("见证双录");
    },
    //跳转修改
    async continueBiz (needClearNodeCode) {//needClearNodeCode 需要清除NODE_CODE
      //TO  这里驳回报错后，就一直提示有问题
      this.$store.commit(this.$types.UPDATE_REJECT_REMARK, this.bizData.REMARK);
      //驳回后需要清除NODE_CODE
      if (needClearNodeCode) {
        await oppService.saveBizData({}, { NODE_CODE: "0", procStatus: this.bizData.PROC_STATUS });
      }
      //预审核驳回跳转到第一个节点
      if (this.apptStatus == "3") {
        this.$router.goNext();
      } else if (this.apptStatus == "12") {
        //终审驳回且有编辑权限跳转到打印节点
        if(this.editAuth && this.witnessAuth){
          this.$router.goRoute("表单打印");
        }else  if(!this.editAuth && this.witnessAuth){
          //柜员只有见证岗权限时，下一步只能跳转到见证节点
          this.goToWitness();
        }else{
          this.alert("无权限续办业务,请先申请权限！");
          return;
        }
      }else{
        this.$router.goNext();
      }
    },
    //我不想办了
    leaveBiz () {
      let that = this;
      that.confirm({
        messageText: "作废后，下次办理业务需重新进行资料录入，确定作废吗？",
        confirmButtonText: "我再想想",
        cancelButtonText: "确认作废",
        cancel_icon: "cancel",
        confirmedAction: function () {
          // that.showRejectMSgBox();
          //确认取消=》返回首页
          that.goToHome();
        },
        canceledAction: function () {
          //调取接口作废业务流水 同时作废该笔业务的关联的双录流水
          Promise.all([
            that.$syscfg.K_Request("W0000177", {
              B_SNO: that.bizData.B_SNO,
              ORG_CODE: that.bizData.ORG_CODE || that.bizData.OP_ORG
            }),
            //强制作废接口 因为双录可能在审核中 也需要作废掉
            that.dualRecordBusiData.PROC_STATUS && ["15"].indexOf(that.dualRecordBusiData.PROC_STATUS) == -1 ? that.$syscfg.K_Request("F0000000", {
              SERVICE_CODE: "QS701093",
              B_SNO: that.dualRecordBusiData.B_SNO,
            }) : { Code: 0 }
          ]).then(function (data) {
            if (data[0].Code == "0" && data[1].Code == "0") {
              that.goToHome();
            } else {
              that.alert("作废流水接口调用失败");
            }
          }).catch(err => {
            consoleLog("作废流水接口调用失败,原因：" + err);
          });
        }
      });
    },
    goToHome () {
      if (this.isLogin) {
        //已经登录成功且不是销户状态 跳转登录后的首页
        this.$router.replace({
          path: "/homeCustomer"
        });
      } else {
        this.$router.replace({
          path: "/home"
        });
      }
    },
    /**
     * 获取当前业务关联的双录流水信息
     */
    getDualRecordBusiData () {
      let that = this,
        acceptParam = that.bizData.ACCEPT_PARAM && JSON.parse(decodeURIComponent(that.bizData.ACCEPT_PARAM)) || {};
      if (!acceptParam.DOUBLE_RECORD_SNO) {
        return {};
      }
      return that.$syscfg.K_Request("F0000036", {
        B_SNO: acceptParam.DOUBLE_RECORD_SNO
      }).then(function (data) {
        that.dualRecordBusiData = data.Data && data.Data.length && data.Data[0] || {};
        return that.dualRecordBusiData;
      });
    },

  }
};
</script>

<style lang="less">
@import "~@/styles/less/variable.less";

.busi-check-wrap.el-container {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: inherit !important;
  background: #ffffff;
  width: 100%;
  height: 100%;
  .content-wrap {
    // margin-top: 24px;
    background: #ffffff;
    border-radius: 8px;
    // width: 56vw;
    width: 100%; 
    height: 100%;
    padding: 5% 25%;
    overflow: auto;
    // max-height: 50vh;
    .content {
      text-align: center;
      background: #ffffff;
      border-radius: 0.05rem;
      p {
        font-size: 0.18rem;
        // margin-bottom: 0.24rem;
        .fontsize-text-medium();
        letter-spacing:1px;
      }
      img {
        width: 50px;
      }
      .failReasonCon {
        // background: #f6f7f9;
        border-radius: 0.05rem;
  
        font-size: 0.16rem;
        text-align: center; 

        display: flex;
        flex-flow: column; 
        align-items: flex-start;
        padding: 24px;
 
        .fail-style {
          &::before{
            content: "•";
            margin-right: 5px;
          }
        }
      }
      .reasonLine {
        color: #d72b2b;
      }
      .failReasonCon p {
        margin-bottom: 8px; 
        text-align: left;
      }
      .failReasonCon p:first-child {
        margin-bottom: 16PX;
      }
    }
  }
  footer {
    display: flex;
    justify-content: center;
    padding: 0.24rem 0;
    width: 100%;
    background: white;
    .el-button {
      &:first-child {
        // background-color: #ffffff;
        // border: solid 1px #b8b8b8;
        // color: #6e6e6e;
      }
      border-radius: 4px;
      // font-size: 20px;
      width: 162px;
      // height: 54px;
      border: none;
      color: #fff;
      background: linear-gradient(
        45deg,
        #E5C48A,
        #E5C48A
      );
      .fontsize-btn-large();
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/bizCheck/bizCheck.vue